import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Experience } from "./components/Experience";
import { FeaturedProject } from "./components/FeaturedProject";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Education } from "./components/Education";
import { Footer } from "./components/Footer";

function App() {
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Experience />
      <FeaturedProject />
      <Skills />
      <Projects />
      <Education />
      {/* <Contact /> */}
      <Footer />
    </div>
  );
}

export default App;
